export const createGlobalDragDrop = ({ onDrop, onDragOver, onDragLeave, onDragStart }) => {
  const handlers = {
    dragOver: (ev) => {
      if (onDragOver) {
        onDragOver(ev);
      }
    },
    dragLeave: (ev) => {
      if (onDragLeave) {
        onDragLeave(ev);
      }
    },
    drop: (ev) => {
      if (onDrop) {
        onDrop(ev);
      }
    },
    dragStart: (ev) => {
      if (onDragStart) {
        onDragStart(ev);
      }
    },
  };

  const addListeners = () => {
    if (typeof document === "undefined") return;
    document.addEventListener("dragover", handlers.dragOver);
    document.addEventListener("dragleave", handlers.dragLeave);
    document.addEventListener("drop", handlers.drop);
    document.addEventListener("dragstart", handlers.dragStart);
  };

  const removeListeners = () => {
    if (typeof document === "undefined") return;
    document.removeEventListener("dragover", handlers.dragOver);
    document.removeEventListener("dragleave", handlers.dragLeave);
    document.removeEventListener("drop", handlers.drop);
    document.removeEventListener("dragstart", handlers.dragStart);
  };

  return { addListeners, removeListeners };
};
